export default __webpack_public_path__ + "static/media/SkybagsRubikPolyester.5255263e.jpg";